import multiguard from "vue-router-multiguard";
import {
    redirectLogin,
    loginRequired,
    isGuest,
    isVerifiedCellphone,
    isVerifiedEmail,
    isRequestCellphoneForgetPassword,
    isVerifiedCellphoneForSmsVerification,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/RouterGuards";

// import auth views
import Login from "./defaultSiteRouteViews/auth/Login";
import Register from "./defaultSiteRouteViews/auth/Register";
import ForgetPassword from "./defaultSiteRouteViews/auth/ForgetPassword";
import EmailResetPassword from "./defaultSiteRouteViews/auth/ResetEmailPassword";
import CellphoneResetPassword from "./defaultSiteRouteViews/auth/ResetCellPhonePassword";
import VerifiedCellphone from "./defaultSiteRouteViews/auth/VerifiedCellphone";
import VerifiedEmail from "./defaultSiteRouteViews/auth/VerifiedEmail";

// site views
import Product from './defaultSiteRouteViews/site/SingleProduct'
import Products from './defaultSiteRouteViews/site/Products'
import SinglePost from "./defaultSiteRouteViews/site/SinglePost";
import SingleCourse from "./defaultSiteRouteViews/site/SingleCourse";
import Posts from "./defaultSiteRouteViews/site/Posts";
import Pages from "./defaultSiteRouteViews/site/Pages";
import Courses from "./defaultSiteRouteViews/site/Course";
import SinglePage from "./defaultSiteRouteViews/site/SinglePage";
import ShoppingCart from "./defaultSiteRouteViews/site/ShoppingCart";
import UnAuthenticatedShoppingCart from "./defaultSiteRouteViews/site/UnAuthenticatedShoppingCart";
import SingleLesson from "./defaultSiteRouteViews/site/SingleLesson";
import verifyTransaction from "./defaultSiteRouteViews/site/VerifyTransaction";
import Factor from "./defaultSiteRouteViews/site/Factor";
import Delivery from "./defaultSiteRouteViews/site/Delivery";
import Payment from "./defaultSiteRouteViews/site/Payment";
import Categories from "./defaultSiteRouteViews/site/Categories";
import Brands from "./defaultSiteRouteViews/site/Brands";
import SingleCategory from "./defaultSiteRouteViews/site/SingleCategory";
import SingleBrand from "./defaultSiteRouteViews/site/SingleBrand";
import FactorAutoPrint from "./defaultSiteRouteViews/site/FactorAutoPrint";
import PostCategories from "./defaultSiteRouteViews/site/PostCategories";
import Search from "./defaultSiteRouteViews/site/Search";
import verifyTransactionWithoutAuthentication
    from "./defaultSiteRouteViews/site/verifyTransactionWithoutAuthentication";
import {getBaseDomain} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import RedirectLoading from "../../components/RedirectLoading";
import Suspend from "@/plugin/views/dashboard/Suspend.vue";


export const redirectToMainDomain = function (to, from, next) {
    window.location.href = getBaseDomain() + to.fullPath
    next();
}

export let siteRoutes = [
    {
        path: '/login',
        name: 'Login',
        components: {site: RedirectLoading},
    },
    // auth routes
    {
        path: '/register',
        name: 'Register',
        components: {site: RedirectLoading},
    },
    {
        path: '/verified-cellphone',
        name: 'VerifiedCellphone',
        components: {site: RedirectLoading},
    },
    {
        path: '/forget-password',
        name: 'ForgetPassword',
        components: {site: RedirectLoading},

    },
    {
        path: '/cellphone-reset-password',
        name: 'CellphoneResetPassword',
        components: {site: RedirectLoading},

    },
    {
        path: '/verify-email-request',
        name: 'VerifyEmailRequest',
        components: {site: RedirectLoading},

    },
    {
        path: '/email/reset/password/:token/:email',
        name: 'EmailResetPassword',
        components: {site: RedirectLoading},
    },
    {
        path: '/auth/email/verified/:id/:hash',
        name: 'VerifiedEmail',
        components: {site: RedirectLoading},

    },
    // products routes
    {
        path: '/products',
        name: 'Products',
        components: {site: RedirectLoading},
    },
    {
        path: '/product/:name',
        name: 'Product',
        components: {site: RedirectLoading},
    }, // todo name should be slug
    // order should
    {
        path: '/delivery',
        name: 'Delivery',
        components: {site: RedirectLoading},
    },
    {
        path: '/shopping-cart',
        name: 'ShoppingCart',
        components: {site: RedirectLoading},
    },
    {
        path: '/un-authenticated-shopping-cart',
        name: 'UnAuthenticatedShoppingCart',
        components: {site: RedirectLoading},
    },
    {
        path: '/factor/:orderId',
        name: 'Factor',
        components: {site: RedirectLoading},
    },
    {
        path: '/payment',
        name: 'Payment',
        components: {site: RedirectLoading},
    },
    {
        path: '/transaction/verify/order/:slug',
        name: 'verifyTransaction',
        components: {site: RedirectLoading},
    },
    {
        path: '/transaction/user/:user/order/:order/verify-payment/without-transaction',
        name: 'verifyTransactionWithoutAuthentication',
        components: {site: RedirectLoading},
    },
    // content routes
    {
        path: '/blog',
        name: 'Posts',
        components: {site: RedirectLoading},
    },
    {
        path: '/posts/:slug',
        name: 'SinglePost',
        components: {site: RedirectLoading},
    },
    {
        path: '/pages',
        name: 'Pages',
        components: {site: RedirectLoading},
    },
    {
        path: '/pages/:slug',
        name: 'SinglePage',
        components: {site: RedirectLoading},
    },
    {
        path: '/course',
        name: 'Courses',
        components: {site: RedirectLoading},
    },
    {
        path: '/course/:slug',
        name: 'SingleCourse',
        components: {site: RedirectLoading},
    },
    {
        path: '/course/:courseSlug/lesson/:slug',
        name: 'SingleLesson',
        components: {site: RedirectLoading},
    },
    {
        path: '/categories',
        name: 'Categories',
        components: {site: RedirectLoading}
    },
    {
        path: '/brands',
        name: 'Brands',
        components: {site: RedirectLoading}
    },
    {
        path: '/category/:slug',
        name: 'SingleCategory',
        components: {site: RedirectLoading}
    },
    {
        path: '/brand/:slug',
        name: 'SingleBrand',
        components: {site: RedirectLoading}
    },
    {
        path: '/post/categories',
        name: 'PostCategories',
        components: {site: RedirectLoading}
    },
    {
        path: '/search/type/:type/words/:words',
        name: 'Search',
        components: {site: RedirectLoading},
    },
    {
        path: '/chat/:slug',
        name: 'SingleChat',
        components: {dashboard: RedirectLoading},
        beforeEnter: multiguard([loginRequired]),
    },
    {
        path: '/wish-list/:user',
        name: 'WishListUser',
        components: {site: RedirectLoading},
    },
    {
        path: '/product/share/:slug',
        name: 'ProductShare',
        components: {site: RedirectLoading},
    },
    {
        path: '/user/order/:slug',
        name: 'FactorWithSlug',
        components: {site: RedirectLoading},
    },
    {
        path: '/suspend',
        name: 'Suspend',
        components: {site: Suspend},
    },
]